import { FleekError } from './FleekError';

type UserProjectLimitExceededErrorOptions = Record<string, never>;

export class UserProjectLimitExceededError extends FleekError<UserProjectLimitExceededErrorOptions> {
  public name = 'UserProjectLimitExceededError';

  constructor() {
    super({});
  }

  toString = () => `Your project is growing! You've reached the maximum number of projects for your account. Upgrade your plan at https://fleek.xyz/pricing to add more projects. Need assistance? Our Support team is ready to help.`
}
